<script>
import BasePublicationsParticipantsExpansionTable from '@/components/admin/collector/publications/BasePublicationsParticipantsExpansionTable.vue'

export default {
  name: 'PublicationsParticipantsExpansionTable',
  extends: BasePublicationsParticipantsExpansionTable,
}
</script>
